// de_pms_channel_manager.ts
// Tłumaczenia dla PMS.ChannelManager.tsx

export const dePmsChannelManager = {

  title: "Channel Manager",

  // ── Sekcje ───────────────────────────────────────────────────────────────
  sections: {
    syncControl:  "Synchronisationssteuerung",
    connections:  "Verbindungen",
    recentSync:   "Letzte Synchronisierungsversuche",
    importLinks:  "Importierte Links",
  },

  // ── Opisy ────────────────────────────────────────────────────────────────
  descriptions: {
    neutral:         "OTA-Verteilung ohne Anbieterbindung, Reservierungsimport, Bestandsschutz und Sync-Monitoring.",
    pushRates:       "Sende Raten und Verfuegbarkeit mit idempotenten Request-Keys.",
    providerStatus:  "Anbieterstatus und Fehlersichtbarkeit.",
    rateRows:        "Raten- und Bestandszeilen fuer den gewaehlten Zeitraum.",
    syncHistory:     "Synchronisierungshistorie und retry-sichere Fehler.",
    externalIds:     "Externe Kanal-IDs, die mit PMS-Reservierungen verknuepft sind.",
  },

  // ── Etykiety ──────────────────────────────────────────────────────────────
  labels: {
    connection:         "Verbindung",
    connections:        "Verbindungen",
    currentPushPayload: "Aktuelle Push-Payload",
  },

  // ── Komunikaty ────────────────────────────────────────────────────────────
  messages: {
    importCompleted:"Reservierungsimport abgeschlossen.",
    importFailed:   "Reservierungsimport fehlgeschlagen.",
    syncFailed:     "Synchronisierung fehlgeschlagen.",
  },

} as const;

export default dePmsChannelManager;
